import styles from './index.module.css';
import FounderPlaceholder from '../../../assets/images/icons/blank_profile_pic.png';
import Kavishka from '../../../assets/images/founders/kavishka.png';
import sandunika from '../../../assets/images/founders/sandunika.png';

const founders = [
    {
        id: 'founder-one',
        name: 'Kavishka Ganepola',
        role: 'Co-Founder',
        image: Kavishka,
        bio: 'Add a short introduction about this founder, their experience, and what they lead at Ardillalabs.',
    },
    {
        id: 'founder-two',
        name: 'Sandunika Hathnapitiya',
        role: 'Co-Founder',
        image: sandunika,
        bio: 'Add a short introduction about this founder, their experience, and what they lead at Ardillalabs.',
    },
];

const Founders = () => (
    <section className={styles.foundersSection} id="founders" aria-labelledby="founders-title">
        <div className="main-container">
            <div className="container-content">
                <div className={styles.sectionHeading}>
                    <p className={styles.eyebrow}>Leadership</p>
                    <h2 id="founders-title">Meet the Founders</h2>
                    <p>The people behind Ardillalabs.</p>
                </div>
                <div className={styles.foundersGrid}>
                    {founders.map((founder) => (
                        <article className={styles.founder} key={founder.id}>
                            <img
                                className={styles.portrait}
                                src={founder.image}
                                alt={`${founder.name}'s portrait`}
                            />
                            <div className={styles.founderDetails}>
                                <p className={styles.role}>{founder.role}</p>
                                <h3>{founder.name}</h3>
                                {/* <p className={styles.bio}>{founder.bio}</p> */}
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default Founders;
